import { CIFRE_ID_PAZIENTE_API, CIFRE_ID_PAZIENTE_JSON } from "./constants";

export const preparaConfig = (data) => {
  if (data) {
    let newData = Object.assign({}, data);
    newData[CIFRE_ID_PAZIENTE_JSON] = data[CIFRE_ID_PAZIENTE_API];
    delete newData[CIFRE_ID_PAZIENTE_API];
    return newData;
  } else return data;
};
